import { useCallback } from "react";
import { AchievementsSeen } from "../utils/achievementsSeenStorage";
import { useDeviceProgress } from "./useDeviceProgress";
export function useAchievementsSeen() {
    const { data: seen, update, syncStatus } = useDeviceProgress<AchievementsSeen>("achievementsSeen");
    const markSeen = useCallback((key: string) => { void update({ kind: "set", key, value: "seen" }); }, [update]);
    return { seen, markSeen, syncStatus };
}
